import React from 'react';

import NaturalPrice from './NaturalPrice/NaturalPrice';
import DiscountValue from './DiscountValue/DiscountValue';
import MonthlyPrice from './MonthlyPrice/MonthlyPrice';
import campaign from '../../../assets/image/4k_campaign.svg';

const PlanDetail = props => {
    return <div className="PlanDetailPriceContainer">
        <div className="PlanDetailDiscount">
          <NaturalPrice price={props.naturalPrice} priceWithTax={props.naturalPriceWithTax} />
          <DiscountValue value={props.discountValue} valueWithTax={props.discountValueWithTax} />
        </div>
        <div className="PlanDetailPrice">
          <div className="PlanDetailDiscountItem">2年お約束割料金 / 月</div>
          <MonthlyPrice price={props.discountPrice} priceWithTax={props.discountPriceWithTax} />
        </div>
        <CampaignIcon fourK={props.fourK} />
        <Labels smartValue={props.smartValue} homeDicount={props.homeDicount} />
      </div>;
  };

export default PlanDetail;

const CampaignIcon = ({ fourK }) => {
  if (fourK === "HDD") {
    return (
      <div className="PlanDetailCampaignIcon">
        <div className="HDDIcon">HDD付きで<br/>録画も簡単！</div>
      </div>
    );
  }

  const fourKPrice = parseInt(fourK, 10);

  if (fourKPrice > 0) {
    return (
      <img src={campaign} className="PlanDetailCampaignIcon" alt="campaign" />
    );
  }

  return null;
};

const Labels = ({ smartValue, homeDicount }) => {
  if (!smartValue && !homeDicount) {
    return null;
  }

  return (
    <div className="PriceDetailSmartValue">
      {!!smartValue && (
        <>
          <span className="orange">auスマートバリュー対象</span>
          <span className="pink">UQ自宅セット割対象</span>
        </>
      )}
      {!!homeDicount && (
        <span className="blue">ソフトバンクおうち割対象</span>
      )}
    </div>
  );
};
